import { Action, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import axios from 'axios';

@Module({namespaced: true, stateFactory: true})
export default class SearchModule extends VuexModule {
  filters = {
    commercialVehicle: false,
    make: '',
    model: '',
    body_type: '',
    gear_shift: '',
    cap_tech: '',
    fuel_type: '',
    ph: '',
    accel: '',
    trunk_cap: '',
    co2emit: '',
    typseat: ''
  };
  makes = [];
  models = [];
  bodyTypes = [];
  capTechs = [];
  fuelTypes = [];
  gearShifts = [];
  phs = [];
  accels = [];
  trunkCaps = [];
  co2emits = [];
  typseats = [];

  /**************************************************
   * Getters
   **************************************************/

  get requestConfig() {
    return {
      params: this.filters
    }
  }

  get filterModel() {
    return this.filters.model;
  }

  /**************************************************
   * Mutations
   **************************************************/

  @Mutation
  setFilters(filters) {
    this.filters = filters;
  }

  @Mutation
  setModels(models) {
    this.models = models;
  }

  /**************************************************
   * Mutation Actions
   **************************************************/

  @MutationAction({mutate: ['makes']})
  async fetchMakes() {
    const response = await axios.get('/api/search/makes', this.getters.requestConfig);

    return {makes: response.data};
  }

  @MutationAction({mutate: ['models']})
  async fetchModels() {
    this.commit('setModels', []);
    const response = await axios.get('/api/search/models', this.getters.requestConfig);

    return {models: response.data};
  }

  @MutationAction({mutate: ['bodyTypes']})
  async fetchBodyTypes() {
    const response = await axios.get('/api/search/body-types', this.getters.requestConfig);

    return {bodyTypes: response.data};
  }

  @MutationAction({mutate: ['capTechs']})
  async fetchCapTechs() {

    const capTechsArr =  [
      {min: 0,max: 1000,name: '1000 cm<sup>3</sup> alatt', slug: '1000-alatt'},
      {min: 1001,max: 1300,name: '1001-1300 cm<sup>3</sup>', slug: '1001-1300'},
      {min: 1301,max: 1700,name: '1301-1700 cm<sup>3</sup>', slug: '1301-1700'},
      {min: 1701,max: 2200,name: '1701-2200 cm<sup>3</sup>', slug: '1701-2200'},
      {min: 2201,max: 900000,name: '2201 cm<sup>3</sup> felett ', slug: '2201-felett'},
    ];

    if (!this.getters.filterModel) {
      return {capTechs: capTechsArr};
    }

    const response = await axios.get('/api/search/cap-tech-list', this.getters.requestConfig);

    let ret = [];

    capTechsArr.forEach(function (item) {
      response.data.forEach(function (capTech) {
        if (item.min < capTech && item.max > capTech) {
          if (!ret.filter(e => e.min === item.min).length > 0) {
            ret.push(item);
          }
        }
      })
    });

    return {
      capTechs: ret
    }
  }


  @MutationAction({mutate: ['fuelTypes']})
  async fetchFuelTypes() {
    const response = await axios.get('/api/search/fuel-types', this.getters.requestConfig);
    return {fuelTypes: response.data};
  }

  @MutationAction({mutate: ['gearShifts']})
  async fetchGearShifts() {
    const response = await axios.get('/api/search/gear-shifts', this.getters.requestConfig);
    return {gearShifts: response.data};
  }

  @MutationAction({mutate: ['phs']})
  async fetchPhs() {

    const phSArr = [
      {min: 0,  max:100, name: '100 LE alatt', slug: "100-alatt"},
      {min: 101,max:150, name: '101-150 LE', slug: "101-150"},
      {min: 151,max:200, name: '151-200 LE', slug: "151-200"},
      {min: 201,max:300, name: '201-300 LE', slug: "201-300"},
      {min: 301,max:2000, name: '301 LE felett', slug: "301-felett"},
    ];

    if (!this.getters.filterModel) {
      return {phs: phSArr};
    }

    const response = await axios.get('/api/search/ph-list', this.getters.requestConfig);

    let ret = [];

    phSArr.forEach(function (item,index) {
      response.data.forEach(function (value) {
        if (item.min < value && item.max > value) {
          if (!ret.filter(e => e.min === item.min).length > 0) {
            ret.push(item);
          }
        }
      })
    });

    return {
      phs: ret
    }
  }

  @MutationAction({mutate: ['accels']})
  async fetchAccels() {

    const accelsArr = [
      {max: 6, min: 0, name: '6mp alatt', slug: '6-alatt'},
      {max: 8, min: 6.1, name: '6,1-8 mp', slug: '6.1-8.0'},
      {max: 10, min: 8.1, name: '8,1-10 mp', slug: '8.1-10.0'},
      {max: 12, min: 10.1, name: '10,1-12 mp', slug: '10.1-12.0'},
      {max: 30, min: 12.1, name: '12,1 mp', slug: '12.1-felett'},
    ];

    if (!this.getters.filterModel) {
      return {accels: accelsArr};
    }

    const response = await axios.get('/api/search/accel-list', this.getters.requestConfig);

    let ret = [];

    accelsArr.forEach(function (item, index) {
      response.data.forEach(function (value) {
        if (item.min < value && item.max > value) {
          if (!ret.filter(e => e.min === item.min).length > 0) {
            ret.push(item);
          }
        }
      })
    });

    return {
      accels: ret
    }
  }

  @MutationAction({mutate: ['trunkCaps']})
  async fetchTrunkCaps() {

    const trunkCapsArr = [
      {min:0,  max:350,name: '350 L alatt', slug: '350-alatt'},
      {min:351,max:450,name: '351-450 L', slug: '351-450'},
      {min:451,max:550,name: '451-550 L', slug: '451-550'},
      {min:551,max:100000,name: '551 L felett', slug: '551-felett'},
    ];

    if (!this.getters.filterModel) {
      return {trunkCaps: trunkCapsArr};
    }

    const response = await axios.get('/api/search/trunk-cap-list', this.getters.requestConfig);

    let ret = [];

    trunkCapsArr.forEach(function (item, index) {
      response.data.forEach(function (value) {
        if (item.min < value && item.max > value) {
          if (!ret.filter(e => e.min === item.min).length > 0) {
            ret.push(item);
          }
        }
      })
    });

    return {
      trunkCaps: ret
    }
  }

  @MutationAction({mutate: ['co2emits']})
  async fetchCo2Emits() {

    const co2EmitsArr = [
      {min: 0,  max:100,name: '100 g/km alatt', slug: '100-alatt'},
      {min: 101,max:130, name: '101-130 g/km', slug: '101-130'},
      {min: 131,max:160, name: '131-160 g/km', slug: '131-160'},
      {min: 161,max:100000, name: '161 g/km felett', slug: '161-felett'},
    ];

    if (!this.getters.filterModel) {
      return {co2emits: co2EmitsArr};
    }

    const response = await axios.get('/api/search/co2emit-list', this.getters.requestConfig);

    let ret = [];

    co2EmitsArr.forEach(function (item, index) {
      response.data.forEach(function (value) {
        if (item.min < value && item.max > value) {
          if (!ret.filter(e => e.min === item.min).length > 0) {
            ret.push(item);
          }
        }
      })
    });

    return {
      co2emits: ret
    }
  }

  @MutationAction({mutate: ['typseats']})
  async fetchTypseats() {

    const response = await axios.get('/api/search/typseat', this.getters.requestConfig);

    return {
      typseats: response.data
    }
  }

  /**************************************************
   * Mutation Actions
   **************************************************/

  @Action
  initializeState() {
    this.context.dispatch('fetchMakes');
    this.context.dispatch('fetchModels');
    this.context.dispatch('fetchBodyTypes');
    this.context.dispatch('fetchCapTechs');
    this.context.dispatch('fetchFuelTypes');
    this.context.dispatch('fetchPhs');
    this.context.dispatch('fetchAccels');
    this.context.dispatch('fetchTrunkCaps');
    this.context.dispatch('fetchCo2Emits');
    this.context.dispatch('fetchGearShifts');
    this.context.dispatch('fetchTypseats');
  }
}
